import ONNXSegmentationController from './ONNXSegmentationController';

export { ONNXSegmentationController };
